import { render, staticRenderFns } from "./101.vue?vue&type=template&id=0c240c36&scoped=true&"
var script = {}
import style0 from "./101.vue?vue&type=style&index=0&id=0c240c36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c240c36",
  null
  
)

export default component.exports